import { useRef, useState } from "react";
import { UploadCloud, Loader2 } from "lucide-react";
import { toast } from "sonner";
import api, { formatApiError } from "../lib/api";

export const UploadZone = ({ onUploaded }) => {
  const inputRef = useRef(null);
  const [dragging, setDragging] = useState(false);
  const [uploading, setUploading] = useState(false);
  const [clientName, setClientName] = useState("");

  const handleFile = async (file) => {
    if (!file) return;
    setUploading(true);
    const form = new FormData();
    form.append("file", file);
    form.append("client_name", clientName);
    try {
      const { data } = await api.post("/documents/upload", form);
      toast.success("Document uploaded — Nexari is analyzing it now.");
      setClientName("");
      onUploaded(data);
    } catch (e) {
      toast.error(formatApiError(e.response?.data?.detail) || "Upload failed");
    } finally {
      setUploading(false);
      if (inputRef.current) inputRef.current.value = "";
    }
  };

  return (
    <div className="space-y-3">
      <input
        data-testid="client-name-input"
        value={clientName}
        onChange={(e) => setClientName(e.target.value)}
        placeholder="Client name (optional)"
        className="w-full bg-white border border-[#E8E6E1] rounded-md px-4 py-2.5 text-sm focus:outline-none focus:ring-2 focus:ring-[#2E5C50]/30 focus:border-[#2E5C50]"
      />
      <div
        data-testid="document-upload-zone"
        onClick={() => !uploading && inputRef.current?.click()}
        onDragOver={(e) => {
          e.preventDefault();
          setDragging(true);
        }}
        onDragLeave={() => setDragging(false)}
        onDrop={(e) => {
          e.preventDefault();
          setDragging(false);
          handleFile(e.dataTransfer.files?.[0]);
        }}
        className={`cursor-pointer border-2 border-dashed rounded-lg p-10 flex flex-col items-center justify-center text-center transition-colors duration-200 ${
          dragging ? "border-[#2E5C50] bg-[#D6E0D9]/20" : "border-[#C9CFC9] bg-white hover:border-[#2E5C50] hover:bg-[#D6E0D9]/10"
        }`}
      >
        {uploading ? (
          <Loader2 className="w-8 h-8 text-[#2E5C50] animate-spin" strokeWidth={1.5} />
        ) : (
          <UploadCloud className="w-8 h-8 text-[#2E5C50]" strokeWidth={1.5} />
        )}
        <p className="mt-3 font-medium text-[#1C211F]">
          {uploading ? "Uploading & analyzing…" : "Drop a document here, or click to browse"}
        </p>
        <p className="mt-1 text-sm text-[#57605A]">PDF, PNG, JPG, WEBP or TXT · max 15 MB</p>
        <input
          ref={inputRef}
          type="file"
          accept=".pdf,.png,.jpg,.jpeg,.webp,.txt"
          className="hidden"
          onChange={(e) => handleFile(e.target.files?.[0])}
        />
      </div>
    </div>
  );
};
